module.exports = __webpack_public_path__ + "img/cp6-6.eabada97.jpg";